import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';

export const QuotaCounter = ({ userEmail }: { userEmail: string | null }) => {
    const [usage, setUsage] = useState(0);
    const [timeLeft, setTimeLeft] = useState("");

    useEffect(() => {
        const loadUsage = () => {
            if (userEmail) {
                const today = new Date().toDateString();
                const savedDate = localStorage.getItem(`quota_date_${userEmail}`);
                
                if (savedDate !== today) {
                    localStorage.setItem(`quota_date_${userEmail}`, today);
                    localStorage.setItem(`quota_${userEmail}`, "0");
                    setUsage(0);
                } else {
                    const savedUsage = localStorage.getItem(`quota_${userEmail}`);
                    setUsage(parseInt(savedUsage) || 0);
                }
            }
        };

        loadUsage();

        const handleUpdate = () => loadUsage();
        window.addEventListener('quota_updated', handleUpdate);
        
        return () => {
            window.removeEventListener('quota_updated', handleUpdate);
        };
    }, [userEmail]);

    useEffect(() => {
        const updateTimer = () => {
             const now = new Date();
             const tomorrow = new Date(now);
             tomorrow.setHours(24, 0, 0, 0);
             const diff = tomorrow.getTime() - now.getTime();
             
             const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
             const minutes = Math.floor((diff / 1000 / 60) % 60);

             setTimeLeft(`${hours}h ${minutes}m`);
        };
        updateTimer();
        const int = setInterval(updateTimer, 60000);
        return () => clearInterval(int);
    }, []);

    if (!userEmail) return null;

    const radius = 16;
    const circumference = 2 * Math.PI * radius;
    const strokeDashoffset = circumference - (Math.min(usage, 100) / 100) * circumference;

    return (
        <div className="flex flex-col items-center gap-1 ml-4 justify-center">
             <div className="relative flex items-center justify-center w-10 h-10">
                 <svg className="transform -rotate-90 w-10 h-10">
                     <circle
                         cx="20"
                         cy="20"
                         r={radius}
                         stroke="rgba(255,255,255,0.1)"
                         strokeWidth="3"
                         fill="transparent"
                     />
                     <motion.circle
                         cx="20"
                         cy="20"
                         r={radius}
                         stroke={usage >= 100 ? "#ef4444" : "#818cf8"}
                         strokeWidth="3"
                         fill="transparent"
                         strokeDasharray={circumference}
                         initial={{ strokeDashoffset: circumference }}
                         animate={{ strokeDashoffset }}
                         transition={{ duration: 1, ease: "easeOut", delay: 0.2 }}
                         style={{ strokeLinecap: 'round' }}
                     />
                 </svg>
                 <div className="absolute inset-0 flex items-center justify-center text-[11px] font-bold text-white tracking-tighter">
                      {usage}%
                 </div>
             </div>
             <div className="flex flex-col items-center">
                 <span className="text-[10px] font-medium text-slate-300 leading-tight block">{usage}% Used</span>
                 {usage >= 100 && (
                      <span className="text-[9px] text-red-400 font-medium leading-tight block whitespace-nowrap mt-0.5">Resets in {timeLeft}</span>
                 )}
                 {usage < 100 && (
                      <span className="text-[9px] text-slate-400 font-medium leading-tight block whitespace-nowrap mt-0.5">Resets in {timeLeft}</span>
                 )}
             </div>
        </div>
    );
};
